/**
 * Editable row shapes for the Tubulars domain. The shared read types
 * (`AssemblyOut` / `CasingOut` / `PipeTallyOut` in `src/api/types.ts`) don't
 * carry the `entity_id` / `version` audit fields, but the Oxbo-P write contract
 * keys PUT on `entity_id`. Rather than touch the shared contract file we widen
 * the read rows locally with the optional audit fields the editor needs.
 */
import type { AssemblyOut, CasingOut, PipeTallyOut } from "@api/types";

/** Audit fields present on the write-contract Out shapes (PUT keys on entity_id). */
export interface RowAudit {
  entity_id?: string | null;
  version?: number | null;
}

export type AssemblyRow = AssemblyOut & RowAudit;
export type CasingRow = CasingOut & RowAudit;
export type PipeTallyRow = PipeTallyOut & RowAudit;

/** The PUT key for a row — prefer entity_id (contract), fall back to id. */
export function rowKey(row: RowAudit & { id: string }): string {
  return row.entity_id ?? row.id;
}
